import React from 'react';
import { Form } from 'react-bootstrap';
import { BsEye, BsEyeSlash } from "react-icons/bs"; // Import the new icons

interface PasswordFieldProps {
  label: string;
  controlId: string;
}

export const PasswordField = React.forwardRef<HTMLInputElement, PasswordFieldProps>(({ label, controlId }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const togglePasswordVisibility = () => {
      setShowPassword(!showPassword);
    };

    return (
      <Form.Group className="mb-3" controlId={controlId}>
        <Form.Label>{label}</Form.Label>
        <div style={{ position: 'relative' }}>
          <Form.Control
            type={showPassword ? "text" : "password"}
            placeholder={label}
            ref={ref}
            required
          />
          <span
            onClick={togglePasswordVisibility}
            style={{
              position: 'absolute',
              right: '10px',
              top: '50%',
              transform: 'translateY(-50%)',
              cursor: 'pointer',
            }}
          >
            {showPassword ? <BsEyeSlash /> : <BsEye />}
          </span>
        </div>
      </Form.Group>
    );
  }
);
